import { render, staticRenderFns } from "./IrisCodes.vue?vue&type=template&id=2d1884e1"
import script from "./IrisCodes.vue?vue&type=script&lang=js"
export * from "./IrisCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports